import { vehicleMonitorPage } from '@/api/waybill';
import { getRegeoPoiAreaInfo } from '@/api/common';

const state = {
  waybillNo: '',
  postParams: {
    page: 1,
    size: 10,
  },
  listData: {
    tableHeadList: [
      {
        label: '序号',
        prop: 'index',
        width: 40,
        checked: 1,
        sortable: true,
      },
      {
        label: '异常提示',
        prop: 'warning',
        width: 300,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-warning',
      },
      {
        label: '处理人',
        prop: 'updateName',
        width: 130,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-updateName',
      },
      {
        label: '备注',
        prop: 'reason',
        width: 190,
        checked: 1,
        sortable: true,
      },
    ],
    list: [],
    total: 0,
  },
};
const getters = {};
const actions = {
  // 获取列表数据
  getList: async context => {
    const { data } = await vehicleMonitorPage(
      Object.assign({}, { waybillNo: context.state.waybillNo }, context.state.postParams),
    );
    data.records.forEach((item, index) => {
      item.index = index + 1;
      function formatAddress(start, end) {
        getRegeoPoiAreaInfo({
          longitude: typeof start === 'string' ? start : start.toString(),
          latitude: typeof end === 'string' ? end : end.toString(),
        }).then(res => {
          try {
            item.address = res.data.keyWords;
            return res.data.keyWords;
          } catch (error) {
            return error;
          }
        });
      }
      formatAddress(item.longitude, item.latitude);
    });

    context.commit('updateState', {
      key: 'listData',
      value: Object.assign(
        {},
        context.state.listData,
        { list: data.records },
        { total: data.total },
      ),
    });
    // context.dispatch('scheduledTask');
    return data.records;
  },
};
const mutations = {
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
